import SidebarLayout from "components/Layout/Layout";
import { useEffect, useState } from "react";
import { FeatureType, SubscriptionType } from "./type";
import getListSupcriptions from "./function/getAllSubcription";
import getAllFeatures from "./function/getAllFeature";
import { Modal } from "antd";
import AddFeaturesModal from "./component/addFeatureModal";
import AddModalSubscriptions from "./component/addSubcriptionsModal";
import SubscriptionDisplayItem from "./component/subcriptionsItem";
import FeatureItems from "./component/featureItems";

const Subscriptions = () => {
    const [subcriptions, setSubscriptions] = useState<SubscriptionType[] | []>([]);
    const [features, setFeatures] = useState<FeatureType[]>([]);
    const [allFeature, setAllFeature] = useState<FeatureType[]>([]);
    const [openAddModalFeature, setOpenAddModalFeature] = useState(false);
    const [openAddModalSubscription, setOpenAddModalSubscription] = useState(false);
    const [activeTab, setActiveTab] = useState<"subscriptions" | "features">("subscriptions");

    const [triggerReload, setTriggerReload] = useState(0);

    // Filter and search features state
    const [filteredFeatures, setFilteredFeatures] = useState<FeatureType[]>([]);
    const [searchName, setSearchName] = useState<string>("");
    const [searchKey, setSearchKey] = useState<string>("");
    const [searchValue, setSearchValue] = useState<string>("");

    function handleOpenAddModal() {
        if (activeTab === "features") {
            setOpenAddModalFeature(true);
        }
        else {
            setOpenAddModalSubscription(true);
        }
    }

    useEffect(() => {
        getListSupcriptions(0, 0, 0).then((res) => {
            setSubscriptions(res);
        }).catch((error) => {
            console.error("Error fetching subscriptions:", error);
        });
        getAllFeatures(0, 0).then((res) => {
            setFeatures(res);
            setAllFeature(res);
            setFilteredFeatures(res);
        }).catch((error) => {
            console.error("Error fetching features:", error);
        });
    }, []);

    useEffect(() => {
        getListSupcriptions(0, 0, 0).then((res) => {
            setSubscriptions(res);
        }).catch((error) => {
            console.error("Error fetching subscriptions:", error);
        });
        getAllFeatures(0, 0).then((res) => {
            setFeatures(res);
            setAllFeature(res);
            setFilteredFeatures(res);
            console.log("Features reloaded");
        }).catch((error) => {
            console.error("Error fetching features:", error);
        });
    }, [triggerReload]);


    return (
        <SidebarLayout
            title={
                (
                    <h4 className="text-2xl font-bold mb-4 text-gray-800 py-4">
                        Subcriptions Dashboard
                    </h4>
                )
            }
        >
            <div className="flex flex-col gap-4">
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <div className="mb-4 flex flex-row justify-between items-center">
                        <div className="flex justify-between items-center mb-4 w-fit">
                            <button className={`px-4 py-2 text-lg font-medium ${activeTab === "subscriptions" ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500"}`} onClick={() => setActiveTab("subscriptions")}>
                                Subcriptions
                            </button>
                            <button className={`px-4 py-2 text-lg font-medium ${activeTab === "features" ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500"}`} onClick={() => setActiveTab("features")}>
                                Features
                            </button>
                        </div>
                        <div>
                            <button
                                onClick={handleOpenAddModal}
                                className="bg-blue-600 !text-white cursor-pointer px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                                + Add New {activeTab === "subscriptions" ? "Subscription" : "Feature"}
                            </button>
                        </div>
                    </div>
                    {
                        activeTab === "subscriptions" ? (
                            <div>
                                {subcriptions.length === 0 ? (
                                    <p>No subscriptions available.</p>
                                ) : (
                                    <div className="grid grid-cols-1 gap-4">
                                        {subcriptions.map((subscription) => (
                                            <SubscriptionDisplayItem
                                                key={subscription.id}
                                                subscription={subscription}
                                                setTriggerReload={setTriggerReload}
                                            />
                                        ))}
                                    </div>
                                )}
                                <Modal
                                    title="Add New Subscription"
                                    open={openAddModalSubscription}
                                    width={800}
                                    onCancel={() => setOpenAddModalSubscription(false)}
                                    footer={null}
                                >
                                    <AddModalSubscriptions
                                        setTriggerReload={setTriggerReload}
                                        onClose={() => setOpenAddModalSubscription(false)} />
                                </Modal>
                            </div>
                        ) : (
                            <div>
                                <div className="flex mb-4 flex-row gap-2">
                                    <input
                                        type="text"
                                        placeholder="Search by Name"
                                        value={searchName}
                                        onChange={(e) => setSearchName(e.target.value)}
                                        className="border p-2 rounded w-1/4 mr-2 border-gray-400"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Search by Key"
                                        value={searchKey}
                                        onChange={(e) => setSearchKey(e.target.value)}
                                        className="border p-2 rounded w-1/4 mr-2 border-gray-400"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Search by Value"
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                        className="border p-2 rounded w-1/4 border-gray-400"
                                    />
                                    <button
                                        onClick={() => {
                                            const filtered = allFeature.filter((feature) => {
                                                return (
                                                    feature.name.toLowerCase().includes(searchName.toLowerCase()) &&
                                                    (feature.key ? feature.key.toLowerCase().includes(searchKey.toLowerCase()) : searchKey === "") &&
                                                    (feature.number !== undefined && feature.number !== null ? feature.number.toString().includes(searchValue) : searchValue === "")
                                                );
                                            });
                                            setFilteredFeatures(filtered);
                                        }}
                                        className="bg-blue-600 !text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
                                    >
                                        Apply Filters
                                    </button>
                                    <button
                                        onClick={() => {
                                            setSearchName("");
                                            setSearchKey("");
                                            setSearchValue("");
                                            setFilteredFeatures(allFeature);
                                        }}
                                        className="border px-4 py-2 rounded hover:bg-gray-400 transition-colors"
                                    >
                                        Clear Filters
                                    </button>
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    {filteredFeatures.map((feature) => (
                                        <FeatureItems
                                            key={feature.id}
                                            feature={feature}
                                            setTriggerReload={setTriggerReload}
                                        />
                                    ))}
                                </div>
                                <Modal
                                    title="Add New Feature"
                                    open={openAddModalFeature}
                                    onCancel={() => setOpenAddModalFeature(false)}
                                    footer={null}
                                >
                                    <AddFeaturesModal onClose={() => setOpenAddModalFeature(false)} />
                                </Modal>
                            </div>
                        )
                    }
                </div>
            </div>
        </SidebarLayout>
    );
};

export default Subscriptions;